var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnContestCrown = function SvgIcnContestCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22H7.5C7.09 22 6.75 21.66 6.75 21.25C6.75 20.84 7.09 20.5 7.5 20.5H17.5C17.91 20.5 18.25 20.84 18.25 21.25C18.25 21.66 17.91 22 17.5 22Z",
    fill: "#FFD31A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8502 5.51906L16.8502 8.37906C16.3202 8.75906 15.5602 8.52906 15.3302 7.91906L13.4402 2.87906C13.1202 2.00906 11.8902 2.00906 11.5702 2.87906L9.67022 7.90906C9.44022 8.52906 8.69022 8.75906 8.16022 8.36906L4.16022 5.50906C3.36022 4.94906 2.30022 5.73906 2.63022 6.66906L6.79022 18.3191C6.93022 18.7191 7.31022 18.9791 7.73022 18.9791H17.2602C17.6802 18.9791 18.0602 18.7091 18.2002 18.3191L22.3602 6.66906C22.7002 5.73906 21.6402 4.94906 20.8502 5.51906ZM15.0002 14.7491H10.0002C9.59022 14.7491 9.25022 14.4091 9.25022 13.9991C9.25022 13.5891 9.59022 13.2491 10.0002 13.2491H15.0002C15.4102 13.2491 15.7502 13.5891 15.7502 13.9991C15.7502 14.4091 15.4102 14.7491 15.0002 14.7491Z",
    fill: "#FFD31A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnContestCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_contest_crown.9f83832d.svg";
export { ForwardRef as ReactComponent };